import { Component, DestroyRef, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GetImageWithGidService } from '@coin/shared/auth/data-access';
import { EmployeeWithMaritalStatus } from '@coin/shared/core/util-models';
import { MasterDataConfig } from './attribute-display.config';
import { MatIcon } from '@angular/material/icon';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { V2CardComponent } from '@coin/shared/core/ui-storybook';
import { DateTimezoneFixPipe } from '@coin/shared/core/util-pipes';

@Component({
  selector: 'coin-siemens-energy-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.scss', '../../styles/gbr-data-point.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2CardComponent, MatIcon, UpperCasePipe, TranslatePipe, DateTimezoneFixPipe]
})
export class PersonalDataComponent implements OnInit {
  private readonly imageService = inject(GetImageWithGidService);
  private readonly destroyRef = inject(DestroyRef);

  @Input() employee: EmployeeWithMaritalStatus;

  public employeeImage: string;
  public masterAttributes = MasterDataConfig;

  ngOnInit(): void {
    this.setEmployeeImage();
  }

  private setEmployeeImage(): void {
    if (!this.employee?.gid) {
      return;
    }

    this.imageService
      .getImageWithStore(this.employee.gid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(image => {
        this.employeeImage = image;
      });
  }
}
